import {
	FiUsers,
	FiHome,
	FiShoppingBag,
	FiPlusCircle,
	FiLogOut,
	FiX,
	FiTag,
} from "react-icons/fi";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "./sidebar.css";

const Sidebar = ({ handleLogout, isOpen, onClose }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const isActiveRoute = (routePath) => {
		return location.pathname.startsWith(routePath);
	};

	return (
		<div className={`client-sidebar${isOpen ? " sidebar-open" : ""}`}>
			<div className="sidebar-header">
				<h3>⚙ Management</h3>
				<button className="sidebar-close-btn" onClick={onClose} aria-label="Close sidebar">
					<FiX />
				</button>
			</div>
			<ul className="sidebar-menu">
				<li className={isActiveRoute("/control-panel/client-dashboard") ? "active" : ""}>
					<NavLink
						to="/control-panel/client-dashboard"
						end
						className={({ isActive }) => (isActive ? "nav-link-active" : "")}
						onClick={onClose}>
						<FiHome className="sidebar-icon" />
						Dashboard
					</NavLink>
				</li>
				<li className={isActiveRoute("/control-panel/our-outlets") ? "active" : ""}>
					<NavLink
						to="/control-panel/our-outlets"
						className={({ isActive }) => (isActive ? "nav-link-active" : "")}
						onClick={onClose}>
						<FiShoppingBag className="sidebar-icon" />
						All Outlets
					</NavLink>
				</li>
				<li className={isActiveRoute("/control-panel/client-management") ? "active" : ""}>
					<NavLink
						to="/control-panel/client-management"
						className={({ isActive }) => (isActive ? "nav-link-active" : "")}
						onClick={onClose}>
						<FiUsers className="sidebar-icon" />
						Client Management
					</NavLink>
				</li>
				<li className={isActiveRoute("/control-panel/categories") ? "active" : ""}>
					<NavLink
						to="/control-panel/categories"
						className={({ isActive }) => (isActive ? "nav-link-active" : "")}
						onClick={onClose}>
						<FiTag className="sidebar-icon" />
						Categories
					</NavLink>
				</li>
				<li className={isActiveRoute("/control-panel/register") ? "active" : ""}>
					<NavLink
						to="/control-panel/register"
						className={({ isActive }) => (isActive ? "nav-link-active" : "")}
						onClick={onClose}>
						<FiPlusCircle className="sidebar-icon" />
						Add New Client
					</NavLink>
				</li>
				<li>
					<NavLink
						to="/"
						className={({ isActive }) => (isActive ? "nav-link-active" : "")}
						onClick={onClose}>
						<FiHome className="sidebar-icon" />
						Home
					</NavLink>
				</li>
			</ul>
			<li className="logout-btn-sidebar" onClick={handleLogout}>
				<FiLogOut className="sidebar-icon" />
				Logout
			</li>
		</div>
	);
};

export default Sidebar;
